var jQuery = require('jquery');

jQuery(window).load(function() {
  jQuery('.primary-header .mode.crumb.right').attr('class', 'mode js-mode flat-crumb flat-crumb-toggle');
});



// WEBPACK FOOTER //
// ./src/lp/editor/toolbar/primary-header-toolbar.js